import { render, staticRenderFns } from "./ShowSelection.vue?vue&type=template&id=5a51bc7a&scoped=true"
import script from "./ShowSelection.vue?vue&type=script&lang=js"
export * from "./ShowSelection.vue?vue&type=script&lang=js"
import style0 from "./ShowSelection.vue?vue&type=style&index=0&id=5a51bc7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a51bc7a",
  null
  
)

export default component.exports